import React from 'react';
import './Footer.css';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot, faPhone, faShoppingBag, faStore } from '@fortawesome/free-solid-svg-icons';
import { useTiendaPrincipal } from '../storeData';

export default function Footer() {
    const { tienda, loading } = useTiendaPrincipal();

    return (
        <footer className='FooterContain'>
            <div className='footerText' id='footerText'>
                <Anchor to='/' className='footerLogoLink'>
                    {tienda?.imagen1 ? (
                        <img src={tienda?.imagen1} alt="logo" />
                    ) : (
                        <img src={logo} alt="logo" />
                    )}
                </Anchor>

                {tienda?.nombre ? (
                    <h2>{tienda?.nombre}</h2>
                ) : loading ? (
                    <span className='footerTextSkeleton'></span>
                ) : null}
            </div>

            <div className='footerText'>
                <h3>Contacto</h3>
                {tienda?.direccion && (
                    <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target="_blank">
                        <FontAwesomeIcon icon={faLocationDot} />
                        <span>{tienda.direccion}</span>
                    </Anchor>
                )}
                {tienda?.email && (
                    <Anchor to={`mailto:${tienda.email}`} target="_blank">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span>{tienda.email}</span>
                    </Anchor>
                )}
                {tienda?.telefono && (
                    <Anchor to={`tel:${tienda.telefono}`} target="_blank">
                        <FontAwesomeIcon icon={faPhone} />
                        <span>{tienda.telefono}</span>
                    </Anchor>
                )}
                <div className='socials'>
                    {tienda?.instagram && <Anchor to={tienda.instagram} target="_blank" aria-label="Instagram"><i className='fa fa-instagram'></i></Anchor>}
                    {tienda?.telefono && <Anchor to={`tel:${tienda.telefono}`} target="_blank" aria-label="WhatsApp"><i className='fa fa-whatsapp'></i></Anchor>}
                    {tienda?.facebook && <Anchor to={tienda.facebook} target="_blank" aria-label="Facebook"><i className='fa fa-facebook'></i></Anchor>}
                </div>
            </div>

            <div className='footerText'>
                <h3>Explorar</h3>
                <Anchor to={`/productos`} className='footerAppLink'>
                    <FontAwesomeIcon icon={faShoppingBag} />
                    <span>Todos los productos</span>
                </Anchor>
                <Anchor to={`/`} className='footerAppLink'>
                    <FontAwesomeIcon icon={faStore} />
                    <span>Inicio de la tienda</span>
                </Anchor>
            </div>

            <div className='footerText footerNote'>
                <h3>Compra facil</h3>
                <p>Catalogo, pedido y contacto directo desde la misma tienda.</p>
            </div>
        </footer>
    );
}
